import React, { createContext, useState } from 'react';

const ChartsContext = createContext();

export const ChartsProvider = ({ children }) => {
    const [updateTime, setUpdateTime] = useState(0);
    const [totalEntries, setTotalEntries] = useState(0);
    const [volunteers, setVolunteers] = useState(0);
    const [englishXlation, setEnglishXlation] = useState(0);
    const [cantoneseXlation, setCantoneseXlation] = useState(0);
    const [do3R5P, setDo3R5P] = useState(0);
    const [shuttleBus, setShuttleBus] = useState(0);
    const [checkIns, setCheckIns] = useState(0);
    const [registrationPerDay, setRegistrationPerDay] = useState(0);
    const [checkin3R5P,setCheckin3R5P] = useState(0)
    const [totalToday, setTotalToday] = useState(0)
    const [relativesCount, setRelativesCount] = useState(0)
    const [totalHeadCount, setTotalHeadCount] = useState(0)
    const [scroll1,setScoll1] = useState(0)
    const [scroll2,setScoll2] = useState(0)
    const [scroll3,setScoll3] = useState(0)
    const [scroll4,setScoll4] = useState(0)
    const [scroll5,setScoll5] = useState(0)
    const [scroll6,setScoll6] = useState(0)
    const [scroll7,setScoll7] = useState(0)
    const [scroll8,setScoll8] = useState(0)
    const [scroll9,setScoll9] = useState(0)
    const [scroll10,setScoll10] = useState(0)
    const [perfectAttendeesCount,setPerfectAttendeesCount] = useState(0)

    const setChartsData = (data) => {
        setVolunteers(data.volunteers || 0);
        setEnglishXlation(data.englishXlation || 0);
        setCantoneseXlation(data.cantoneseXlation || 0);
        setDo3R5P(data.do3R5P || 0);
        setShuttleBus(data.shuttleBus || 0);
        setTotalEntries(data.totalEntries || 0);
        setCheckIns(data.checkIns || 0);
        setRegistrationPerDay(data.registrationPerDay || 0);
        setCheckin3R5P(data.checkin3R5P || 0);
        setTotalToday(data.totalToday || 0);
        setRelativesCount(data.relativesCount || 0);
        setTotalHeadCount(data.totalHeadCount || 0);
        setScoll1(data.scroll1 || 0);
        setScoll2(data.scroll2 || 0);
        setScoll3(data.scroll3 || 0);
        setScoll4(data.scroll4 || 0);
        setScoll5(data.scroll5 || 0);
        setScoll6(data.scroll6 || 0);
        setScoll7(data.scroll7 || 0);
        setScoll8(data.scroll8 || 0);
        setScoll9(data.scroll9 || 0);
        setScoll10(data.scroll10 || 0);
        setPerfectAttendeesCount(data.perfectAttendeesCount || 0);
    };

    return (
        <ChartsContext.Provider value={{
            updateTime,
            setUpdateTime,
            totalEntries,
            setTotalEntries,
            volunteers,
            setVolunteers,
            englishXlation,
            setEnglishXlation,
            cantoneseXlation,
            setCantoneseXlation,
            do3R5P,
            setDo3R5P,
            shuttleBus,
            setShuttleBus,
            checkIns,
            setCheckIns,
            setChartsData,
            registrationPerDay,
            setRegistrationPerDay,
            checkin3R5P,
            setCheckin3R5P,
            totalToday,
            setTotalToday,
            relativesCount,
            setRelativesCount,
            totalHeadCount,
            setTotalHeadCount,
            scroll1,
            scroll2,
            scroll3,
            scroll4,
            scroll5,
            scroll6,
            scroll7,
            scroll8,
            scroll9,
            scroll10,
            perfectAttendeesCount
        }}>
            {children}
        </ChartsContext.Provider>
    );
};

export default ChartsContext;
